import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-heading__txt" }

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'page-heading',
  props: {
    modifires: { type: [String, Array, Boolean] }
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('page-heading', _ctx.modifires))
  }, [
    _createElementVNode("h1", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})